
import Api from './Api';
export const getHttp = async (url, params) => {
    try {
        const res = await Api.get(url, {
            params,
        });
        const {data} = res;
        return {response: data?.data, success: true, message: ''};
    } catch (e) {
        return {response: [], success: false, message: ' Error', error: ''};
    }
};

export const postHttp = async (url, body, multiPart = false) => {
    try {
        const res = await Api.post(url, body,{headers: {'Content-Type': multiPart? 'multipart/form-data'  : 'text/json'}});
        const {data} = res;
        return {response: data?.data, success: true, message: '', status: 201};
    } catch (e ) {
        const {response} = e;
        console.log('e ', response.data)
        return {response: [], success: false, message: 'Error', status: response.status, errorData: response?.data};
    }
};
